import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription, throwError, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ICost, IPrice } from '../../../../pricing/interfaces/pricing.interface';

// SERVICES
import { EnvironmentUtilService } from '../../util';
import { ApiService } from '../api.service';
@Injectable({
  providedIn: 'root',
})
export class PricingApiService {
  private readonly _loading = new BehaviorSubject<boolean>(<boolean>false);
  private readonly _pricingByRfq = new BehaviorSubject<{
    [key :string] :IPrice;
  }>(<{ [key :string] :IPrice }>{});
  private readonly _unitCostByRfq = new BehaviorSubject<{
    [key :string] :ICost;
  }>(<{ [key :string] :ICost }>{});
  private readonly _pricings = new BehaviorSubject<{
    [key :string] :IPrice;
  }>(<{ [key :string] :IPrice }>{});

  loading$ = this._loading.asObservable();
  pricingByRfq$ = this._pricingByRfq.asObservable();
  pricings$ = this._pricings.asObservable();

  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  getByRfq(params ?:{ [param :string] :string }) :Subscription {
    this._loading.next(true);

    return this.apiService
      .get(`${this.environment.urlV2}/pricing/price`, {
        params,
      })
      .subscribe({
        next: (response) => {
          const rfqId :string = params ? params['rfqId'] : '';
          this._pricingByRfq.next({
            [rfqId]: response,
          });
          this._loading.next(false);
        },
        error: (error) => throwError(() => new Error(error)),
      });
  }

  getByRfqV2(params ?:{ [param :string] :string }) :Observable<any> {
    return this.apiService.get(`${this.environment.urlV2}/pricing/price`, {
      params,
    });
  }

  getRfqPriceAsync(params ?:{ [param :string] :string }) :Observable<any> {
    return this.apiService.get(`${this.environment.urlV2}/pricing/price`, {
      params,
    });
  }

  getUnitCostByRfq(params ?:{ [param :string] :string }) :Observable<ICost> {
    return this.apiService.get(`${this.environment.urlV2}/pricing/unit-cost`, {
      params,
    });
  }

  get unitCostByRfq$() :Observable<{ [key :string] :ICost }> {
    return this._unitCostByRfq.asObservable();
  }
}
